<script>
///Ultima alteração: 28/01/2021
///Alterado por: Alini

    import { link }   from "svelte-routing";
    import { createEventDispatcher, afterUpdate } from 'svelte';
    import { alt, textTelefone, linkTelefone, textWhatsapp, linkWhatsapp, linkAV } from '../store.js';    

	// Componentes
    import HeaderItem           from './Header__Item.svelte';
    
    // Code
    export let classe           = "";
	export let logo 		    = "/assets/images/logo.png";    
    export let logoHeight       = "60px";
    export let logoMobile 	    = logo;
    export let logoWidth        = "auto";
    export let style            = "";

    export let menu             = [];
            
    export let menuSecondary     = [];

	afterUpdate(() => { 
        let bodyMargin = jQuery('header').innerHeight();
        jQuery('body').css('margin-top', bodyMargin);
    });
</script>

<header class="header header-follower header--{style} {classe}">
    <div class="container">
        <nav class="navbar-expand-lg navbar">
            <a class="logo navbar-brand" href="/home" use:link replace title="Ir para Home">
                <img class="img-fluid d-none d-lg-block" src="{logo}" alt="Logo{$alt}" width="{logoWidth}" style="max-height: {logoHeight};">
                <img class="img-fluid d-lg-none" src="{logoMobile}" alt="Logo{$alt}" width="{logoWidth}" style="max-height: {logoHeight};">
            </a>
            <button class="navbar-toggler" data-toggle="collapse" data-target=".navbar-collapse" aria-controls="navbar-collapse" aria-expanded="false" aria-label="Alterna navegação">
                <div class="navbar-toggler-icon">
                    <span aria-hidden="true"></span>
                    <span aria-hidden="true"></span>
                    <span aria-hidden="true"></span>                        
                </div>
            </button>
            {#if style == "double"}
                <div class="navbar-collapse collapse justify-content-end">
                    <ul class="navbar-nav menu menu--top d-none d-lg-flex">
                        {#each menuSecondary as item}
                            <HeaderItem {...item} />
                        {/each}
                    </ul>
                    <ul class="navbar-nav menu menu--bottom">
                        {#each menu as item}
                            <HeaderItem {...item} />
                        {/each}
                    </ul>		
                    <ul class="navbar-nav menu menu--top d-lg-none">
                        {#each menuSecondary as item}
                            <HeaderItem {...item} />
                        {/each}
                    </ul>
                </div>
            {:else}
                <div class="navbar-collapse collapse justify-content-end">
                    <ul class="navbar-nav menu">
                        {#each menu as item}
                            <HeaderItem {...item} />
                        {/each}
                    </ul>
                </div>
            {/if}
        </nav>
    </div>
</header>

<style type="text/sass">
@import 'public/assets/sass/variables.sass'

/* Header */
header 
    .navbar 
        padding: 0
        .logo
            padding: 0
        .menu 
            align-items: center     

.header--double
    .navbar-collapse
        +transition(all 0.5s)
        padding: 0
        flex-direction: column
        align-items: flex-end
        margin: 0 -20px
        padding: 10px           
        .menu--bottom
            border-top: 1px solid #f1f1f1
            +media-breakpoint-up(lg)	
                margin-top: 10px
                padding-top: 10px

/* Menu Mobile */
.navbar-toggler
    .navbar-toggler-icon
        position: relative
        span
            background-color: #000
            display: block
            height: 3px
            position: absolute
            transform-origin: center
            transition-duration: 86ms
            transition-property: background-color,opacity,transform
            transition-timing-function: ease-out
            width: 25px
            &:nth-child(1)
            top: calc(50% - 10px)
            &:nth-child(2)
                top: calc(50% - 1px)
            &:nth-child(3)
                top: calc(50% + 8px)
    &[aria-expanded="true"]
        .navbar-toggler-icon span
            &:nth-child(1)
                transform: translateY(10px) rotate(45deg)
            &:nth-child(2)
                opacity: 0
            &:nth-child(3)
                transform: translateY(-8px) rotate(-45deg)
</style>